<template>
    <span>
        <home-hero
            headline="We create digital products and data insights to fight SARS-CoV-2!"
            text="We are an international volunteer group of professionals from various fields united by one mission: bring the virus down!"
            button
        >
        </home-hero>
        <home-youtube></home-youtube>
        <home-projects></home-projects>
        <home-footer></home-footer>
    </span>
</template>

<script>
import HomeHero from '../components/HomeHero';
import HomeDetails from '../components/HomeDetails';
import HomeProjects from '../components/HomeProjects';
import HomeFooter from '../components/HomeFooter';
import HomeYoutube from '../components/HomeYoutube';

export default {
    name: 'home',
    components: {
        HomeHero,
        HomeDetails,
        HomeProjects,
        HomeFooter,
        HomeYoutube
    }
};
</script>
